<script>
	export let headline = '';
	export let className = '';
</script>

{#if headline != undefined && headline.length > 0}
	<h2 class={`text-3xl pb-px text-center font-semibold text-white light:bg-gradient-to-br from-[#4D4F9A] via-[#593D87] to-[#431E52] bg-clip-text light:text-transparent  ${className}`}>{@html headline}</h2>
{/if}

